import { useQuery } from "@tanstack/react-query";

import { useAggregatedDataV2 } from "~/hooks/useAggregatedDataV2.ts";
import userViewGuard from "~/hooks/useViewPermssionsCheck";
import {
	centralInvoiceRecipientQueries,
} from "~/modules/billing/api/centralInvoiceRecipient/centralInvoiceRecipientQueries.ts";
import { useAllClients } from "~/modules/client/api/client/clientQueries";
import { useAllCompanies } from "~/modules/client/api/company/companyQueries.ts";
import CentralInvoiceRecipientDetailsView
	from "~/modules/client/components/centralInvoiceRecipient/CentralInvoiceRecipientsIndexView.tsx";
import { useAllCompanyAvatarImages } from "~/modules/image/api/avatarImage/avatarImageQueries.ts";
import LoadingPage from "~/pages/LoadingPage";
import { PermissionNames } from "~/types/entityNames.ts";

const CentralInvoiceRecipientsIndexPage: React.FC = () => {
	const guard = userViewGuard(PermissionNames.CanManageProjects);
	if (guard) return guard;

	const { data, options } = useAggregatedDataV2({
		allCompanyAvatarImages: useAllCompanyAvatarImages(),
		centralInvoiceRecipients: useQuery(centralInvoiceRecipientQueries.all()),
		companies: useAllCompanies(),
		clients: useAllClients(),
	});

	if (options.loadingPercent < 100) return <LoadingPage pcent={options.loadingPercent} />;
	return <CentralInvoiceRecipientDetailsView {...data} />;
};

export default CentralInvoiceRecipientsIndexPage;
